import { t } from '@trimble/i18n';
import { BasicButton } from '@trimble/ui-components/solidjs';
import { JSX } from 'solid-js';
import PopupManager from './PopupManager';

export const PopupButton = (): JSX.Element => {
  return (
    <div>
      <BasicButton
        iconName={'launch'}
        action={() => {
          new PopupManager().open();
        }}
        tooltip={t('general.popup.popout')}
      />
    </div>
  );
};
